import { render, staticRenderFns } from "./NewThread.vue?vue&type=template&id=18d5160e"
import script from "./NewThread.vue?vue&type=script&lang=js"
export * from "./NewThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports